import { render, staticRenderFns } from "./expenseDetails.vue?vue&type=template&id=63ecf9dc&scoped=true&"
import script from "./expenseDetails.vue?vue&type=script&lang=js&"
export * from "./expenseDetails.vue?vue&type=script&lang=js&"
import style0 from "./expenseDetails.vue?vue&type=style&index=0&id=63ecf9dc&lang=less&scoped=true&"
import style1 from "./expenseDetails.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ecf9dc",
  null
  
)

export default component.exports